import { toRosterMemberKey } from '@sorrem-client/ui/shared/roster-member-key';
import type { CrucibleMember } from '@sorrem/shared';
import type { PartyPanelRow } from '@sorrem-client/ui/features/Hud';

/**
 * The gathering's party panel rows: every member, the viewer included, in
 * party order, with their character's essence, whether they're ready, and
 * who leads (the crucible's creator). Keyed as the run's rows are, so the
 * panel reads the same in both.
 */
export function resolveGatheringPartyRows(members: readonly CrucibleMember[], leaderAccountId: string): PartyPanelRow[] {
    return members.map((member) => ({
        key: toRosterMemberKey(member),
        name: member.characterName ?? member.displayName,
        essence: Math.max(0, member.essence ?? 0),
        maxEssence: member.maxEssence ?? 0,
        marker: member.isReady === true ? 'ready' : 'not-ready',
        fallenSecondsLeft: null,
        isLeader: member.accountId === leaderAccountId,
    }));
}
